import { AgentConversation } from '@/agent/conversations/store/slice'
import { getConversationTimestamp } from '../conversation-navigation/util/get-conversation-timestamp'
import { ChatListSidebarItem } from './schema'

/**
 * Map to Chat List Sidebar Item
 * A helper function that maps AgentConversations to ChatListSidebarItems
 * for rendering conversations in the chat list sidebar.
 *
 * @param conversations - The list of AgentConversations to map
 * @returns - The list of ChatListSidebarItem objects
 */
export function mapToChatListSidebarItem(conversations: AgentConversation[]): ChatListSidebarItem[] {
  return conversations.map((conv) => ({
    id: conv.id,
    title: conv.title,
    modified_on: getConversationTimestamp(conv),
    matter_id: conv.matter_id,
  }))
}
